// extracted by mini-css-extract-plugin
export default {"footerText":"SibiFooter_footerText__znJ5W","sibiFooter":"SibiFooter_sibiFooter__ADsSP","footerPadding":"SibiFooter_footerPadding__DJel6","navItem":"SibiFooter_navItem__voZc1"};